import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Box } from "@mui/material";
import { GoogleSvg } from "../CommonSvgs";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const gmailSettings = [
  {
    step: 1,
    description: `Go to your Google Account's <b style="color: #016AFF;">Security Settings</b>`,
  },
  {
    step: 2,
    description: `Enable <b style="color: #016AFF;">2-step verification</b>`,
  },
  {
    step: 3,
    description: `Create an <b style="color: #016AFF;">App password</b> <br/> 
      <span style="color: #3B4858;">Select 'Other' for both App and Device.</span>`,
  },
];

const SetUpAppPasswordModalUi = ({
  openSetUpPasswordModal,
  setOpenSetUpPasswordModal,
}) => {
  const handleClick = (action) => {
    setOpenSetUpPasswordModal(action);
  };
  return (
    <Dialog
      open={openSetUpPasswordModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => handleClick("Cancel")}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <GoogleSvg />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#000",
                fontSize: "18px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Connect Your Google Account
            </p>
            <span
              style={{
                fontWeight: 600,
                color: "#868686",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                marginTop: "-4px",
              }}
            >
              Gmail / G-Suite
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent
        id="alert-dialog-slide-description"
        sx={{ paddingBottom: "0px" }}
      >
        <Box
          sx={{
            borderBottom: "1px solid #DDD",
            padding: "6px 0px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontWeight: 600,
              color: "#868686",
              fontSize: "16px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
            }}
          >
            Enable 2-step verification & generate App password
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "center",
              padding: "12px 0px",
            }}
          >
            <OndemandVideoIcon sx={{ color: "#017BFE" }} />
            <p
              style={{
                fontWeight: 600,
                color: "#017BFE",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              See tutorial video
            </p>
          </div>
        </Box>
        <ul
          style={{
            padding: "10px 0px",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {gmailSettings.map((item) => (
            <li
              style={{
                listStyleType: "none",
                fontWeight: 400,
                display: "flex",
                alignItems: "flex-start",
                gap: 4,
                color: "#000",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              <span style={{ fontWeight: 700 }}>{item.step}.</span>{" "}
              <span dangerouslySetInnerHTML={{ __html: item.description }} />
            </li>
          ))}
        </ul>
      </DialogContent>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 14,
          padding: "10px 14px 14px 10px",
        }}
      >
        <button
          onClick={() => handleClick("Cancel")}
          style={{
            backgroundColor: "transparent",
            fontWeight: 400,
            color: "#1C485F",
            border: "1px solid #1C485F",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            borderRadius: 5,
            gap: 1,
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => handleClick("Ok")}
          style={{
            backgroundColor: "#FF3301",
            fontWeight: 400,
            color: "#FFF",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "10px 14px",
            borderRadius: 5,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          Continue
        </button>
      </div>
    </Dialog>
  );
};

export default SetUpAppPasswordModalUi;
